const timeFilter = (value) => {
  let numToStr = (number) => (number > 9 ? number.toString() : '0' + number);
  let hr = parseInt(((value / 60 / 60) % 24).toString());
  let min = parseInt(((value / 60) % 60).toString());
  let sec = parseInt((value % 60).toString());
  return `${numToStr(hr)}:${numToStr(min)}:${numToStr(sec)}`;
};

const numToChinese = (n) => {
  const chineseBigNum = '一二三四五六七八九十';
  return chineseBigNum[n];
};

// 替换数字为字符
export const toChineseBig = (num) => {
  if (num > 99) return num;
  const strNum = String(num);
  let result = '';
  if (strNum.length === 2) {
    const ca = strNum.split('');
    let p = ca[0],
      s = ca[1];

    if (p === '1') {
      result = '十';
      if (s !== '0') {
        result += numToChinese(parseInt(s) - 1);
      }
    } else {
      result = numToChinese(parseInt(p) - 1) + '十';
      if (s !== '0') {
        result += numToChinese(parseInt(s) - 1);
      }
    }
  } else {
    result = numToChinese(num - 1);
  }
  return result;
};

export default {
  timeFilter,
  toChineseBig
};
